// extracted by mini-css-extract-plugin
export default {"container":"styles_container__Pv1Ih","label":"styles_label__A3MOh","input":"styles_input__GooK-"};